import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import grocery from './modules/grocery'

Vue.use(Vuex)

export default new Vuex.Store<{ auth: typeof auth, grocery: typeof grocery }>({})
